<template>
  <div :style="'height: 100%; position: relative;' + getBackStyle()">
    <div v-show="isShow(idx)" v-for="(image, idx) in element.images" :style="getElementImageStyle(image)" :key="idx" class="element-item"></div>
    <template v-if="bgScale">
      <img :src="min.image" v-for="(min, m_idx) in element.min_list" :key="'min-' + m_idx" :style="getElementDivStyle(min)" :class="'element-item ' + getElementMinClassName(min)" />
    </template>
  </div>
</template>
<script>

export default {
  name: 'ElementPreview',
  components: {
  },
  props: {
    element: {},
    bgScale: null
  },
  data () {
    return {
      showIdx: 0,
      isBack: false,
      xSymbol: 0,
      ySymbol: 0
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getBackStyle () {
      var style = ''
      if (this.isBack) {
        style += '-webkit-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + (180 + parseInt(this.element.rotate_y)) + 'deg);'
        style += '-moz-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + (180 + parseInt(this.element.rotate_y)) + 'deg);'
        style += '-ms-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + (180 + parseInt(this.element.rotate_y)) + 'deg);'
        style += 'transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + (180 + parseInt(this.element.rotate_y)) + 'deg);'
        return style
      } else {
        style += '-webkit-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + this.element.rotate_y + 'deg);'
        style += '-moz-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + this.element.rotate_y + 'deg);'
        style += '-ms-transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + this.element.rotate_y + 'deg);'
        style += 'transform: rotateX(' + this.element.rotate_x + 'deg) rotateY(' + this.element.rotate_y + 'deg);'
        return style
      }
    },
    isShow (idx) {
      return this.showIdx === idx
    },
    goImage () {
      setTimeout(() => {
        this.showIdx += 1
        if (this.element.images.length - this.showIdx <= 0) {
          this.showIdx = 0
        }
        this.goImage()
      }, this.element.rate * 1000)
    },
    clickTrajectory () {
      if (this.element.is_trajectory === 1) {
        this.xSymbol = this.element.trajectory_x_offset - this.element.x_offset
        this.ySymbol = this.element.trajectory_y_offset - this.element.y_offset
      }
    },
    trajectoryImage () {
      if (this.element.is_trajectory === 1) {
        var symbolXoffset = null
        var symbolYoffset = null
        if (this.isBack) {
          if (this.xSymbol !== null) {
            symbolXoffset = this.xSymbol / (this.element.trajectory_rate * 10)
            if (this.element.symbol_x_offset) {
              this.$set(this.element, 'symbol_x_offset', this.element.symbol_x_offset - symbolXoffset)
            } else {
              this.$set(this.element, 'symbol_x_offset', symbolXoffset)
            }
            if (this.xSymbol > 0) {
              if (this.element.symbol_x_offset <= 0) {
                this.isBack = false
                this.trajectoryImage()
                return false
              }
            } else if (this.xSymbol < 0) {
              if (this.element.symbol_x_offset >= 0) {
                this.isBack = false
                this.trajectoryImage()
                return false
              }
            }
          }
          if (this.ySymbol !== 0) {
            symbolYoffset = this.ySymbol / (this.element.trajectory_rate * 10)
            if (this.element.symbol_y_offset) {
              this.$set(this.element, 'symbol_y_offset', this.element.symbol_y_offset - symbolYoffset)
            } else {
              this.$set(this.element, 'symbol_y_offset', symbolYoffset)
            }
          }
        } else {
          if (this.xSymbol !== 0) {
            symbolXoffset = this.xSymbol / (this.element.trajectory_rate * 10)
            if (this.element.symbol_x_offset) {
              this.$set(this.element, 'symbol_x_offset', this.element.symbol_x_offset + symbolXoffset)
            } else {
              this.$set(this.element, 'symbol_x_offset', symbolXoffset)
            }
            if (this.xSymbol > 0) {
              if (this.element.symbol_x_offset + this.element.x_offset > this.element.trajectory_x_offset) {
                this.isBack = true
                this.trajectoryImage()
                return false
              }
            } else if (this.xSymbol < 0) {
              if (this.element.symbol_x_offset + this.element.x_offset < this.element.trajectory_x_offset) {
                this.isBack = true
                this.trajectoryImage()
                return false
              }
            }
          }
          if (this.ySymbol !== 0) {
            symbolYoffset = this.ySymbol / (this.element.trajectory_rate * 10)
            if (this.element.symbol_y_offset) {
              this.$set(this.element, 'symbol_y_offset', this.element.symbol_y_offset + symbolYoffset)
            } else {
              this.$set(this.element, 'symbol_y_offset', symbolYoffset)
            }
          }
        }

        setTimeout(() => {
          this.trajectoryImage()
        }, this.element.trajectory_rate * 10)
      }
    },
    inArray (search, array) {
      for (var i in array) {
        if (array[i] === search) {
          return true
        }
      }
      return false
    },
    getElementMinClassName (min) {
      var className = ''
      if (min.animation) {
        className += ' ' + min.animation + '-' + min.parameter.rate
      }
      return className
    },
    getElementDivStyle (element) {
      var style = ''
      style += 'top: ' + (this.bgScale * element.y_offset) + 'px;'
      style += 'left: ' + (this.bgScale * element.x_offset) + 'px;'
      style += 'width: ' + (this.bgScale * element.width) + 'px;'
      style += 'height: ' + (this.bgScale * element.height) + 'px;'
      return style
    },
    getElementImageStyle (image) {
      var style = 'background-image: url("' + image + '");'
      return style
    }
  },
  mounted () {
    this.goImage()
    this.clickTrajectory()
    this.trajectoryImage()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/map/elementPreview.vue